export default "__VITE_ASSET__DLLXu$NJ__"